import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

export const cleanUpSessionGuard = (keysToClear: string[]): CanActivateFn =>
    (ars: ActivatedRouteSnapshot, rss: RouterStateSnapshot) => {
        for (const keyToClear of keysToClear)
            sessionStorage.removeItem(keyToClear);

        return true;
    }  